import {
  Box,
  Flex,
  Heading,
  Text,
  Select,
  Input,
  // Textarea,
  Divider,
  VStack,
  Button,
  // Icon,
  // Link,
  // Collapse,
} from "@chakra-ui/react";
// import { ExceptionIcon } from "../../styles/icons/ExceptionIcon";
import { useEffect, useState } from "react";
// import { FileExclamation } from "../../styles/icons/FileExclamation";
// import { HistoryIcon } from "../../styles/icons/HistoryIcon";
import { useAnticipation } from "../../hooks/useAnticipation";
import { useParams } from "react-router-dom";
import { showToast } from '../../utils';
import { NumericFormat } from 'react-number-format';

type RateType = 'FIXED' | 'SPREAD' | 'CDI';

interface RateModel {
  type: RateType;
  value: number;
  active: boolean;
  annualEffectiveRate: number;
  monthlyEffectiveRate: number;
}

interface PostRateResponse {
  monthlyCDI: number;
  annualCDI: number;
  models: RateModel[];
}

interface InfoBoxProps {
  isDisabled: boolean;
  label: string;
  value: string;
  isLoading: boolean;
}

const InfoBox = ({ isDisabled,isLoading, label, value }: InfoBoxProps) => (
  <VStack backgroundColor={"#FBFCFE"} border={"1px solid #E6E9F0"} borderRadius={"4px"} p="12px" align="start" spacing={0} minW="120px">
    <Text fontSize="12px" w="145px" fontWeight="400" color={isDisabled ? "gray.300" : "black"}>
      {label}
    </Text>
    {value !== "undefined%" && isLoading === false ?
      <Text
        color={isDisabled ? "gray.100" : "black"}
        fontSize="21px"
        fontWeight="bold"
      >{value}</Text> : isLoading === true ?
      <Text>
        Carregando ... 
      </Text> :
      <Text
      color={isDisabled ? "gray.100" : "black"}
      fontSize="21px"
      fontWeight="bold"
      >
         Sem Taxas
      </Text>
    }
  </VStack>
);

export function AntecipationOnDemand() {
  // const [currentTime] = useState<Date>(new Date());
  // const formattedDate = currentTime.toLocaleDateString("pt-BR");
  // const formattedTime = currentTime.toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" });
  // const [showMore, setShowMore] = useState<boolean>(false);
  const [isEdit, setIsEdite] = useState<boolean>(false);
  // const { email } = JSON.parse(localStorage.getItem("barte-user-info") || "{}");
  const { postAntecipationRate, getAntecipationRate } = useAnticipation();
  const [antecipation, setAntecipation] = useState<PostRateResponse | null>(null);
  const [type, setType] = useState<RateType>("CDI");
  const [value, setValue] = useState<number>(0);
  const [valueObservation] = useState<string>("");
  const [discardChanges, setDiscargeChanges] = useState<number>(0);
  const { id } = useParams<{ id: string }>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  useEffect(() => {
    
    async function fetchData() {

      try {
        setIsLoading(true)
        const data = await getAntecipationRate(id);
  
        if (data) {
          setAntecipation(data);
          setType(data.models[0]?.type ? data.models[0]?.type: "CDI");
          setValue(data.models[0]?.value || 0);
        }
      } catch (error) {
        return error;
      }finally {
        setIsLoading(false)
      }
    }
    fetchData();
    
    // eslint-disable-next-line 
  }, [id, discardChanges]);

  async function postAntecipation() {
    try {
      const response = await postAntecipationRate({
        observation: valueObservation,
        idSeller: id,
        models: [{
          type: type,
          value: value,
          active: true,
        }]
      });

      showToast({ type: 'success', message: 'Taxas Carregadas com sucesso' });
      setIsEdite(false);
      setDiscargeChanges(discardChanges + 1);
      return response;
    } catch (error) {
      showToast({ type: 'error', message: 'Erro ao carregar Taxa' });
      return error;
    }
  }

  const handleValueChange = (values: { floatValue: number | undefined }) => {
    if (values.floatValue !== undefined) {
      setValue(values.floatValue);
    }
  };

  return (
    <Flex gap="38px" flexDirection={"column"} mx="auto">
      <Flex
        gap="12px"
        // w="100%"
        alignItems="center"
        justifyContent="flex-end"
      >
        {isEdit === true ?
          <>
            <Button
              variant={"outline"}
              w="174px"
              h="32px"
              fontSize="14px"
              lineHeight="22px"
              letterSpacing={0}
              onClick={() => {
                setDiscargeChanges(discardChanges + 1);
                setIsEdite(false);
              }}
            >
              Descartar mudanças
            </Button>
            <Button
              backgroundColor="#1890FF"
              color="white"
              fontSize="14px"
              w="87px"
              h="32px"
              onClick={() => postAntecipation()}
              fontWeight={400}
              lineHeight="22px"
              letterSpacing={0}
            >
              Concluir
            </Button>
          </> :
          <Button
            variant={"outline"}
            mt="0"
            borderRadius="2px"
            border={"1px solid #D9D9D9"}
            bgColor={"white"}
            p="0 0.5rem"
            fontSize="14px"
            onClick={() => setIsEdite(true)}
          >
            Editar
          </Button>
        }
      </Flex>
      <Heading mb="-32px" size="sm" >
        Gestão de taxas de antecipação
      </Heading>

      <Flex w="100%" gap="24px" justifyContent={"space-between"}>
        <Flex alignItems="end" w="100%" gap="24px" >
          <Box>
            <Text fontSize="xs" color="#8A94A8">
              Modelo de taxas
            </Text>
            <Select
              borderColor="#C3CAD7"
              backgroundColor="#F5F5F5"
              h="29px"
              w="180px"
              disabled={!isEdit}
              value={type}
              onChange={(e) => setType(e.target.value as RateType)}
            >
              <option value="CDI">Percentual CDI</option>
              <option value="SPREAD">Spread</option>
              <option value="FIXED">Taxa Fixa Mensal</option>
            </Select>
          </Box>

          <Box>
            <Text fontSize="xs" color={"#8A94A8"} >
              {type === "SPREAD" ? "Spread percentual" : type === "FIXED" ? "Taxa fixa Mensal" : type === "CDI" ? "Taxa percentual" : ""}
            </Text>
            <NumericFormat
              customInput={Input}
              value={value}
              onValueChange={handleValueChange}
              decimalSeparator=","
              decimalScale={4}
              suffix="%"
              disabled={!isEdit}
              borderColor="#C3CAD7"
              borderRadius="4px"
              backgroundColor="#F5F5F5"
              h="29px"
              w="180px"
            />
          </Box>
        </Flex>
        <Flex gap="24px" h="71px" w="100%" >
          <InfoBox isDisabled={!isEdit} isLoading={isLoading} label="Taxa efetiva anual" value={`${antecipation?.models[0]?.annualEffectiveRate}%`} />
          <InfoBox isDisabled={!isEdit}  isLoading={isLoading}label="Taxa efetiva mensal" value={`${antecipation?.models[0]?.monthlyEffectiveRate}%`} />
          <InfoBox isDisabled={!isEdit}  isLoading={isLoading}label="CDI Anual" value={`${antecipation?.annualCDI}%`} />
          <InfoBox isDisabled={!isEdit}  isLoading={isLoading}label="CDI Mensal" value={`${antecipation?.monthlyCDI}%`} />
        </Flex>
      </Flex >
      <Divider />
      {/* <Box >
        <Heading size="sm" mb={2} display="flex" alignItems="center" gap={2}>
          <Icon as={FileExclamation} /> Observações
        </Heading>
        <>
          <Text
            position={"absolute"}
            p=" 5px 10px"
            fontSize="xs"
            mb={1}
            color={!isEdit ? "gray.300" : "gray.600"}
          >
            {formattedDate} - {formattedTime} - {email}
          </Text>

          <Textarea
            onChange={(e) => setValueObservation(e.target.value)}
            disabled={isEdit === false}
            p="25px 10px" borderRadius="md" h="96px" w="1121px" />
        </>
      </Box> */}

      {/* <Divider />

      <Flex gap="32px" alignItems="start" flexDirection={"column"}   >
        <Heading size="sm" mb={2} display="flex" alignItems="center" gap={2}>
          <Icon as={ExceptionIcon} /> Histórico de alterações
        </Heading>
        {[1, 2, 3].map((_, i) => (
          <Box
            key={i}
          >
            <Text fontSize="xs" color="gray.600">
              28/05/2022 - 17h12 - vanessa@barte.com
            </Text>
            <Text mb={1}>Migração de base com valores default. Negociação de tempo de repasse do cartão para D+5.</Text>
            <Link
              fontSize="sm" color="blue.500" display={"flex"} gap="10px" alignContent={"center"} alignItems={"center"} alignSelf={"center"}  >
              <HistoryIcon />
              Ver alterações
            </Link>
          </Box>
        ))}

        <Button
          size="sm"
          variant="link"
          onClick={() => setShowMore(!showMore)}
          mt={-2}
        >
          + Ver mais
        </Button>

        <Collapse in={showMore} animateOpacity>
          <Box
          >
            <Text fontSize="xs" color="gray.600">
              28/05/2022 - 17h12 - vanessa@barte.com
            </Text>
            <Text mb={1}>Migração de base com valores default. Negociação de tempo de repasse do cartão para D+5.</Text>
            <Link fontSize="sm" color="blue.500" display={"flex"} gap="10px" alignContent={"center"} alignItems={"center"} alignSelf={"center"}  >
              <HistoryIcon />
              Ver alterações
            </Link>
          </Box>
        </Collapse>
      </Flex> */}
    </Flex>
  );
}
